<template>
  <div class="flex items-center justify-center w-full async-loading bg-gray-50 dark:bg-gray-800">
    <div class="px-3 py-1 text-xs text-center text-blue-800 bg-blue-200 rounded-full animate-pulse dark:bg-blue-900 dark:text-blue-200">
      loading...
    </div>
  </div>
</template>
